import React, { ChangeEvent, useState } from "react";
import { useStores } from "src/stores/rootStore";
import { FeedbackDto } from "../../stores/models/qarFormModels";
import { Button, TextField, DialogActions, DialogContent } from "@material-ui/core";
import { Rating } from "@material-ui/lab";

export const QARFeedBack = () => {

  const { userStore, uiStateStore, qarFormStore } = useStores();

  const [reaction, setReaction] = useState<number | null>(null);
  const [feedbackComment, setFeedbackComment] = useState<string | null>("");

  const submitFeedback = async () => {
    uiStateStore.setModalOpen(false);
    uiStateStore.setModalContent(undefined);

    const data: FeedbackDto = {
      authorId: userStore.currentUserID,
      reaction: reaction!,
      content: feedbackComment
    };

    await qarFormStore.saveFeedback(data);

  };

  const cancelFeedback = () => {
    uiStateStore.setModalOpen(false);
    uiStateStore.setModalContent(undefined);
  }

  const handleSelect = (_event: ChangeEvent<{}>, value: number | null) => {
    setReaction(value);
  };

  const handleTextInput = (event: ChangeEvent<HTMLInputElement>) => {
    setFeedbackComment(event.target.value);
  };

  return (
    <div className="qar-form-feedback-container">
      <h2>Would you share feedback?</h2>
      <DialogContent dividers={true}>
        <div className="qar-form-feedback-rating">
          <Rating
            name="size-large"
            defaultValue={undefined}
            size="large"
            onChange={handleSelect}
          />
        </div>
        <TextField
          label={reaction === null ? "Please, rate your experience" : "Optionally, describe your feedback"}
          inputProps={{ maxLength: 1500 }}
          disabled={reaction === null}
          onChange={handleTextInput}
          id="standard-basic"
          variant="filled"
          size="medium"
          multiline
          minRows={2}
          maxRows={4}
          fullWidth
        />
      </DialogContent>
      <DialogActions className="qar-form-feedback-buttons">
        <Button onClick={cancelFeedback} color="primary">
          Cancel
        </Button>
        <Button onClick={submitFeedback} color="primary" disabled={reaction === null}>
          Submit
        </Button>
      </DialogActions>
    </div>
  );
};
